import { useState } from 'react';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_INFORMATION_MODAL } from '../utils/constants';
import { isMobileScreen } from '../utils/breakpoints';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import styles from './InformationModal.module.scss';

const InformationModal = () => {
  const [stack, setStack] = useState([]);

  const handleOpen = ({
    title,
    body,
    fullscreenOnMobile = false
  }) => {
    setStack(prev => [...prev, { title, body, fullscreenOnMobile }]);
  };

  const { handleModalClose } = useMediatorModalHandle({
    channel: OPEN_INFORMATION_MODAL,
    onOpen: handleOpen
  });

  const handleCloseAll = () => {
    setStack([]);
    handleModalClose();
  };

  const handleBack = () => {
    setStack(prev => prev.slice(0, -1));
  };

  const currentItem = stack[stack.length - 1];
  const isOpen = stack.length > 0;

  return isOpen ? (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseAll}
      size={currentItem.fullscreenOnMobile && isMobileScreen() ? 'fullscreen' : undefined}
      className={styles['information-modal']}
    >
      <ModalHeader
        className={styles['information-modal__header']}
        onRequestClose={handleCloseAll}
        onRequestBack={handleBack}
        showBack={stack.length > 1}
        label={currentItem.title}
      />
      <ModalBody className={styles['information-modal__body']}>
        {currentItem.body}
      </ModalBody>
    </Modal>
  ) : null;
};

export default InformationModal;
